var map = {
	"./STACKS/Print pattern XL-01.svg": 1424,
	"./STACKS/Print pattern size L seam allowance.svg": 1425,
	"./TEMPLATES/02/Print pattern XS-02_colorbase_3000-01.png": 1426,
	"./TEMPLATES/02/Print pattern XS-02_logobase_3000-01.png": 1427,
	"./TEMPLATES/02/template-preview.png": 1428,
	"./TEMPLATES/03/Print pattern XS-03_colorbase_3000-01.png": 1429,
	"./TEMPLATES/03/Print pattern XS-03_logobase_3000-01.png": 1430,
	"./TEMPLATES/03/template-preview.png": 1431,
	"./TEMPLATES/Print pattern XS-01.svg": 1432,
	"./TEMPLATES/Print pattern XS-01_seam_-01.png": 1433,
	"./TEMPLATES/no-image.png": 1434,
	"./XS": 967,
	"./XS.mtl": 967,
	"./XS.obj": 1435,
	"./config": 1000,
	"./config.json": 1000
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2011;